import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message, Button } from 'semantic-ui-react'
// import _find from 'lodash/find';
// import _ from 'lodash';

import ListaDe from '../../../components/funcionales/dirmayor/listade';
import ListaCi from '../../../components/funcionales/dirmayor/listaci';
import ListaZo from '../../../components/funcionales/dirmayor/listazo';
import ListaBa from '../../../components/funcionales/dirmayor/listaba';
import selDirmayor from '../../../functions/seldirmayor';

//utils
import queries from '../../../utils/queries'

import SeguroPermite from '../../../components/funcionales/seguropermite'

import _ from 'lodash';

// "use strict";

//dropdown TARIFAS
const DetalleSelTar = props => {
  return (
    <option dato1={props.elemento.cicloFact} value={props.elemento.codigoTarifa}>{props.elemento.codigoTarifa} ={">"} {props.elemento.descrTarifa}</option>
  )
};

//Tarifa actual
const ListaTarA = ({styles, list, handleChange}) => {
  const detalleTar = list.map((elemento, _id) => <DetalleSelTar styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="tarifaA" id="tarifaA" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar...</option>
        {detalleTar}
      </select>
    </div>
  )
};

//Tarifa nueva
const ListaTarN = ({styles, list, handleChange}) => {
  const detalleTar = list.map((elemento, _id) => <DetalleSelTar styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="tarifaN" id="tarifaN" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar...</option>
        {detalleTar}
      </select>
    </div>
  )
};
//Fin dropdown TARIFAS
//dropdown ESTRATOS
const DetalleNivelES = props => {
  return (
    <option value={props.elemento.descrEstrato}>{props.elemento.descrEstrato}</option>
  )
};

const ListaES = ({styles, list, handleChange}) => {
  const NivelDetalleES = list.map((elemento, _id) => <DetalleNivelES styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrEstrato" id="miListaE" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar...</option>
        {NivelDetalleES}
      </select>
    </div>
  )
};//Fin dropdown ESTRATOS
//Lista de clientes a los que se les va a actualizar la tarifa
const ActTar = ({elemento}) => {
  return(
    <tr className=''>
      <td className=''>{elemento.contrato}</td>
      <td className=''>{elemento.descrClaseServ}</td>
      <td className=''>{elemento.descripcionServicio}</td>
      <td className='right aligned'>{elemento.valorServiciosTA}</td>
      <td className='right aligned'>{elemento.valorAntesImptosTA}</td>
      <td className='right aligned'>{elemento.valorServicios}</td>
      <td className='right aligned'>{elemento.valorAntesImptos}</td>
    </tr>
  )
};

const ListaAT = ({list}) => {
  const nivel1Detalle = list.map((elemento, i) => <ActTar elemento={elemento} key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

let fechaHoy = new Date()
fechaHoy = (fechaHoy.getFullYear()+1) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
// let fechaPA = new Date()
// fechaPA = fechaPA.getFullYear() + '-' + ((fechaPA.getMonth()+1)<10?'0'+(fechaPA.getMonth()+1):(fechaPA.getMonth()+1)) + '-' + (fechaPA.getUTCDate()<10?'0'+fechaPA.getUTCDate():fechaPA.getUTCDate())

const argsBuscarCL = {numDocum: 1}

class ProcAT2 extends React.Component {
  state={argsDocum: {fechaPA: "", fechaRef: fechaHoy, codigoTarifaA: "Seleccionar...", cicloFact: "",
        codigoTarifaN: "Seleccionar...", descrEstrato: "Seleccionar...",
        descrDpto: "Todos...", nombreCiudad: "Todas...", nombreZona: "Todas...", nombreBarrio: "Todos..."},
        creaColeccAct: [], creaColeccNOAct: [], creaColeccMas1Serv: [], actRenta: [],
        argsSelDpto: this.props.argsSelDpto, listaCliAT: [], totCli: 0,
        permiteUpdate: true, confirmaAct: false, open: false, errors: []}

  handleChange = (ev) => {
    let listaCliAT = [], creaColeccAct = [], creaColeccNOAct = [], creaColeccMas1Serv = []
    this.setState({listaCliAT, creaColeccAct, creaColeccNOAct, creaColeccMas1Serv})
    let argsDocum = this.state.argsDocum
    if(ev.target.name === "descrEstrato"){
      let miLista = document.getElementById("miListaE");
      if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
        argsDocum['descrEstrato'] = miLista.options[miLista.selectedIndex].value
      }else{
        argsDocum['descrEstrato'] = "Seleccionar..."
      }
    }else{
      if(ev.target.name === "tarifaA"){
        let miLista = document.getElementById("tarifaA");
        if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
          argsDocum['codigoTarifaA'] = miLista.options[miLista.selectedIndex].value
          argsDocum['cicloFact'] = miLista.options[miLista.selectedIndex].attributes[0].value
        }else{
          argsDocum['codigoTarifaA'] = "Seleccionar..."
          argsDocum['cicloFact'] = ""
        }
      }else{
        if(ev.target.name === "tarifaN"){
          let miLista = document.getElementById("tarifaN");
          if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
            argsDocum['codigoTarifaN'] = miLista.options[miLista.selectedIndex].value
          }else{
            argsDocum['codigoTarifaN'] = "Seleccionar..."
          }
        }else{
          // if(ev.target.name === "fechaPA"){
          //   let miLista = document.getElementById("miListaE");
          //   if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
          //     argsDocum['fechaPA'] = miLista.options[miLista.selectedIndex].value
          //   }else{
          //     argsDocum['descrEstrato'] = "Seleccionar..."
          //   }
          // }else{
      
          const argsDocum = this.state.argsDocum
          argsDocum[ev.target.name] = ev.target.value
          // }
        }
      }
    }
    // console.log(argsDocum)
    this.setState({argsDocum});
  }

  handleSubmit = async (ev)=>{
    // console.log(ev.target.name)
    let targetName = ev.target.name
// if(ev.target.name==="pantalla"){
//   console.log("click en pantalla")
// }else{
//   console.log("generar dx")
// }
//ACTUALIZAR BD
async function crudBD(operacionCRUD, args, i) {
  console.log("CRUD")
        if(args.ctrlCampo === 'CRUD'){
  // console.log(i)
  // console.log(args)
          const {data} = await operacionCRUD({
            variables: args
          });
  
  //Se utiliza para traer el _id del documento creado
          if(args.ctrl_id === 'SI_ID'){
            if(Object.values(data)[0]._id){
              return Object.values(data)[0]._id
            }else{
              return 0
            }
          }
        }else{
          if(args.ctrlCampo === "MANY"){
            // console.log("MANY")
            // console.log(args)
            // const {data} = await operacionCRUD({
            await operacionCRUD({
              variables: args
            });
          }
        }
      }
  
  //ENVIO PARA ACTUALIZAR BD
      async function updColecc(crudColecc, argsCrud, totDocCRUD) {
  // console.log(argsCrud)
  // console.log(totDocCRUD)
        let codigo = 0
        // console.log(argsCrud)
        if(argsCrud[0].ctrl_id === 'SI_ID'){
          codigo = await crudBD(crudColecc[0], argsCrud[0], 0)
        }else{
          await crudBD(crudColecc[0], argsCrud[0], 0)
        }
        if(codigo!==0){
          for(let i=1; i<totDocCRUD; i++){
            argsCrud[i]._id = codigo
          }
        }
  // console.log("inicio")
        for(let i=1; i<totDocCRUD; i++){
          await crudBD(crudColecc[i], argsCrud[i], i)
        }
  console.log("final")
      }

  if(targetName==="pantalla"){
    document.body.style.cursor = 'wait'
    let argsUpd
    let errors = []
    if(!this.props.allClientesRtes.allClientesRtes){
      errors.push({path: "Act Tarifa", message: "Proceso de actualización de tarifa a clientes, por favor espere un momento..."});
    }
    if(!this.state.argsDocum.fechaPA){
      errors.push({path: "Fecha Primera Activación", message: "Debe seleccionar la fecha de Primera Activación"});
    }
    if(this.state.argsDocum.codigoTarifaA==="Seleccionar..."){
      errors.push({path: "Tarifa actual", message: "Debe seleccionar la tarifa actual"});
    }
    if(this.state.argsDocum.codigoTarifaN==="Seleccionar..."){
      errors.push({path: "Tarifa nueva", message: "Debe seleccionar la tarifa nueva"});
    }

    // console.log(this.state.argsDocum)
    this.setState({errors})
    if(errors.length===0){
      let clientesAT = [], argsBuscarCL = ""
      if(this.state.argsDocum.descrEstrato!=="Seleccionar..."){
        argsBuscarCL = `'descrEstrato': '${this.state.argsDocum.descrEstrato}'`
      }
      if(this.state.argsDocum.codigoTarifaA!=="Seleccionar..."){
        if(argsBuscarCL){argsBuscarCL += `, `}
        argsBuscarCL += `'tarifa.codigoTarifa': '${this.state.argsDocum.codigoTarifaA}'`
      }
      if(this.state.argsDocum.fechaPA){
        if(argsBuscarCL){argsBuscarCL += `, `}
        argsBuscarCL += `'fechaPrimeraActivacion': {$lte: new Date('${this.state.argsDocum.fechaPA}')}`
      }

      //Seleccionar clientes del dpto, ciudad, zona y barrio seleccionados
      if(this.state.argsSelDpto.descrDpto===undefined||this.state.argsSelDpto.descrDpto==="Todos..."){

      }else{
        if(this.state.argsSelDpto.nombreCiudad===undefined||this.state.argsSelDpto.nombreCiudad==="Todas..."){
          if(argsBuscarCL){argsBuscarCL += `, `}
          argsBuscarCL += `'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}'`
        }else{
          if(this.state.argsSelDpto.nombreZona===undefined||this.state.argsSelDpto.nombreZona==="Todas..."){
            if(argsBuscarCL){argsBuscarCL += `, `}
            argsBuscarCL += `'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}'`
            argsBuscarCL += `, 'dirmayor.ciudades.nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}'`
          }else{
            if(this.state.argsSelDpto.nombreBarrio===undefined||this.state.argsSelDpto.nombreBarrio==="Todos..."){
              if(argsBuscarCL){argsBuscarCL += `, `}
              argsBuscarCL += `'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}'`
              argsBuscarCL += `, 'dirmayor.ciudades.nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}'`
              argsBuscarCL += `, 'dirmayor.ciudades.zonas.nombreZona': '${this.state.argsSelDpto.nombreZona}'`
            }else{
              if(argsBuscarCL){argsBuscarCL += `, `}
              argsBuscarCL += `'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}'`
              argsBuscarCL += `, 'dirmayor.ciudades.nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}'`
              argsBuscarCL += `, 'dirmayor.ciudades.zonas.nombreZona': '${this.state.argsSelDpto.nombreZona}'`
              argsBuscarCL += `, 'dirmayor.ciudades.zonas.barrios.nombreBarrio': '${this.state.argsSelDpto.nombreBarrio}'`
            }
          }
        }
      }

      if(this.props.allClientesRtes.allClientesRtes){
        // console.log("filtrar")
        argsBuscarCL = '{' + argsBuscarCL + '}'
        argsBuscarCL = {tipoqry: `[{$match: ${argsBuscarCL}}, {$sort: {contrato: 1}}]`}
        // console.log(argsBuscarCL)
        let {data} = await this.props.allClientesRtes.refetch(argsBuscarCL)
        clientesAT = await data.allClientesRtes
        // console.log(clientesAT.length)
        // let {data} = await this.props.allClientesRtes.refetch(argsBuscarCL)
        // clientesAT = await data.allClientesRtes
      }
      // clientesAT = clientesAT.filter(elemento => elemento.tarifa.codigoTarifa===this.state.argsDocum.codigoTarifaA)

      let list6 = this.props.allTarifa.allTarifa
      let indexLis = list6.findIndex( tarifan => tarifan.codigoTarifa === this.state.argsDocum.codigoTarifaN );
      let serviciosN = list6[indexLis].servicios
      let descrTarifaN = list6[indexLis].descrTarifa
      let cicloFact = list6[indexLis].cicloFact
      // console.log(serviciosN)
      // console.log(clientesAT.length)
      // console.log(this.state.argsDocum)
      let listaCliAT = []
      let totCli = 0
      let creaColeccAct = [], creaColeccNOAct = [], creaColeccMas1Serv = [], movColecc = [], actRenta = []

      clientesAT.forEach((elemento, _id) => {
        let servColecc = []
        let cliAT = false, actTar = true
        if(elemento.tarifa){
          // console.log(elemento.contrato, elemento.tarifa)
          if(elemento.cicloFact===cicloFact){
            elemento.tarifa.servicios.forEach(async (elementoA, _id) => {
              indexLis = serviciosN.findIndex( servicio => servicio.codigoServicio === elementoA.codigoServicio );
              if(indexLis===-1){
                // console.log(elemento.contrato)
                actTar = false
              }
            })
          }else{
            actTar = false
          }
          if(actTar){
            let listServTar = serviciosN.map(servicio => ({...servicio}))
            let cargoMensual = 0
            elemento.tarifa.servicios.forEach(async (elemento2, _id) => {
              indexLis = serviciosN.findIndex( servicio => servicio.codigoServicio === elemento2.codigoServicio );
              listServTar[indexLis].numeroServicios = elemento2.numeroServicios
              let valorS = null
              let servFinal = 0
              movColecc = []
              // console.log("11", elemento2.codigoServicio, elemento2.colorServicio, elemento2)

              if(Number(elemento2.numeroServicios)>=Number(listServTar[indexLis].rango1NumServValorIni)){
                if(Number(elemento2.numeroServicios)>Number(listServTar[indexLis].rango1NumServValorFin)){
                  valorS = listServTar[indexLis].rango1NumServValorFin * listServTar[indexLis].rango1Valor
                }else{
                  valorS = elemento2.numeroServicios * listServTar[indexLis].rango1Valor
                }
                servFinal = listServTar[indexLis].rango1NumServValorFin
              }
              if(listServTar[indexLis].rango2NumServValorIni!==null&&Number(elemento2.numeroServicios)>=Number(listServTar[indexLis].rango2NumServValorIni)){
                if(Number(elemento2.numeroServicios)>Number(listServTar[indexLis].rango2NumServValorFin)){
                  valorS += (listServTar[indexLis].rango2NumServValorFin - servFinal) * listServTar[indexLis].rango2Valor
                }else{
                  valorS += (elemento2.numeroServicios - servFinal) * listServTar[indexLis].rango2Valor
                }
                servFinal = listServTar[indexLis].rango2NumServValorFin
              }
              if(listServTar[indexLis].rango3NumServValorIni!==null&&Number(ev.target.value)>=Number(listServTar[indexLis].rango3NumServValorIni)){
                if(Number(elemento2.numeroServicios)>Number(listServTar[indexLis].rango3NumServValorFin)){
                  valorS += (listServTar[indexLis].rango3NumServValorFin - servFinal) * listServTar[indexLis].rango3Valor
                }else{
                  valorS += (elemento2.numeroServicios - servFinal) * listServTar[indexLis].rango3Valor
                }
              }
              if(valorS!==null&&valorS!==''){
                let valorI = 0
                listServTar[indexLis].imptos.forEach((elemento1, _id) => {
                  valorI += Math.round(valorS * (elemento1.porcImpto / 100))
                  movColecc.push({codigoImpto: elemento1.codigoImpto,
                    descrImpto: elemento1.descrImpto, porcImpto: elemento1.porcImpto,
                    valorImpto: Math.round(valorS * (elemento1.porcImpto / 100))})
                })
                valorS = (Math.round((valorS + valorI) / 10) * 10) - valorI
                listServTar[indexLis].valorAntesImptos = valorS
                valorS += valorI
                // this.setState({movColecc});
              }
              listServTar[indexLis].valorServicios = valorS
              // listServTar[indexLis].imptos = movColecc

              argsUpd = {}
              argsUpd = {
                "contrato": elemento.contrato,
                "descripcionServicio": elemento2.descripcionServicio,
                "descrClaseServ": elemento2.subclaseserv.claseserv.descrClaseServ,
//Valor servicios tarifa nueva
                "valorServicios": listServTar[indexLis].valorServicios,
                "valorAntesImptos": listServTar[indexLis].valorAntesImptos,
//Valor servicios tarifa actual
                "valorServiciosTA": elemento2.valorServicios,
                "valorAntesImptosTA": elemento2.valorAntesImptos,
              }
// console.log(argsUpd)
// console.log(listServTar[indexLis])
              listaCliAT.push(argsUpd)

              argsUpd = {
                "codigoServicio": elemento2.codigoServicio,
                "nombreResumido": elemento2.nombreResumido,
                "descripcionServicio": elemento2.descripcionServicio,

                "subclaseserv": {_id: elemento2.subclaseserv._id,
                  codigoSubclaseServ: elemento2.subclaseserv.codigoSubclaseServ,
                  descrSubclaseServ: elemento2.subclaseserv.descrSubclaseServ,
                  claseserv: {_id: elemento2.subclaseserv.claseserv._id,
                    codigoClaseServ: elemento2.subclaseserv.claseserv.codigoClaseServ,
                    descrClaseServ: elemento2.subclaseserv.claseserv.descrClaseServ
                  }},
      
                // "_idSubclaseServ": elemento2.subclaseserv._id,
                // "codigoSubclaseServ": elemento2.subclaseserv.codigoSubclaseServ,
                // "descrSubclaseServ": elemento2.subclaseserv.descrSubclaseServ,
                // "_idClaseServ": elemento2.subclaseserv.claseserv._id,
                // "codigoClaseServ": elemento2.subclaseserv.claseserv.codigoClaseServ,
                // "descrClaseServ": elemento2.subclaseserv.claseserv.descrClaseServ,

                "estadoServicio": elemento2.estadoServicio,

                "rango1NumServValorIni": listServTar[indexLis].rango1NumServValorIni,
                "rango1NumServValorFin": listServTar[indexLis].rango1NumServValorFin,
                "rango1Valor": listServTar[indexLis].rango1Valor,
                "rango2NumServValorIni": listServTar[indexLis].rango2NumServValorIni,
                "rango2NumServValorFin": listServTar[indexLis].rango2NumServValorFin,
                "rango2Valor": listServTar[indexLis].rango2Valor,
                "rango3NumServValorIni": listServTar[indexLis].rango3NumServValorIni,
                "rango3NumServValorFin": listServTar[indexLis].rango3NumServValorFin,
                "rango3Valor": listServTar[indexLis].rango3Valor,
                "numeroServicios": elemento2.numeroServicios,
                "valorServicios": listServTar[indexLis].valorServicios,
                "valorAntesImptos": listServTar[indexLis].valorAntesImptos,
                "velEfecDownstream": listServTar[indexLis].velEfecDownstream,
                "velEfecUpstream": listServTar[indexLis].velEfecUpstream,
                "codigoTipoTec": listServTar[indexLis].codigoTipoTec,
                "descrTipoTec": listServTar[indexLis].descrTipoTec,
                "colorServicio": listServTar[indexLis].colorServicio,
                "imptos": movColecc,
//Valor servicios tarifa actual
              }
              servColecc.push(argsUpd)
              cargoMensual += argsUpd.valorServicios

              cliAT = true
            })
            if(cliAT){
              totCli += 1
// console.log(cargoMensual)
              let argsAdd = {}
              argsAdd['tipoAct'] = "EditarTarifa"
              argsAdd['contrato'] = elemento.contrato
              argsAdd['tarifa'] = {codigoTarifa: this.state.argsDocum.codigoTarifaN,
                descrTarifa: descrTarifaN,
                fechaVence: this.state.argsDocum.fechaRef,
                servicios: servColecc}

              if(servColecc.length===1){
                if(elemento.estadoCliente==="ACTIVO"){
                  creaColeccAct.push(argsAdd)
                }else{
                  creaColeccNOAct.push(argsAdd)
                }
              }else{
                creaColeccMas1Serv.push(argsAdd)
              }

              //Para actualizar la renta mensual
              argsUpd = {
                "tipoAct": "EditarCliOdeS",
                "_id": elemento._id,
                "estadoCliente": elemento.estadoCliente,
                "cargoMensual": cargoMensual,
                "saldoPendiente": elemento.saldoPendiente,
                // "cicloFact": cicloFact,
              }
              actRenta.push(argsUpd)
            }
          }
        }
      })
// console.log(creaColeccAct, creaColeccNOAct, creaColeccMas1Serv)
      this.setState({listaCliAT})
      this.setState({totCli})
      this.setState({creaColeccAct})
      this.setState({creaColeccNOAct})
      this.setState({creaColeccMas1Serv})
      this.setState({actRenta})

      clientesAT = []
      argsBuscarCL={}
      argsBuscarCL.numDocum = 1
      if(this.props.allClientesRtes.allClientesRtes){
        let {data} = await this.props.allClientesRtes.refetch(argsBuscarCL)
        clientesAT = await data.allClientesRtes
      }
    }
    document.body.style.cursor = 'default'
  }
    if(targetName==="excel"){
      var tableToExcel = (function() {
        var tmpElemento = document.createElement('a')
  //window.btoa => Encode a string in base-64
        var uri = 'data:application/vnd.ms-excel;base64,'
          , template = `<html xmlns:o="urn:schemas-microsoft-com:office:office"
                              xmlns:x="urn:schemas-microsoft-com:office:excel">
                          <head>
                            <!--[if gte mso 9]>
                              <xml><x:ExcelWorkbook>
                                    <x:ExcelWorksheets>
                                      <x:ExcelWorksheet>
                                        <x:Name>{worksheet}</x:Name>
                                        <x:WorksheetOptions><x:DisplayGridlines/>
                                        </x:WorksheetOptions>
                                      </x:ExcelWorksheet>
                                    </x:ExcelWorksheets>
                                  </x:ExcelWorkbook>
                              </xml>
                            <![endif]-->
                          </head>
                          <body><table>{table}</table></body>
                        </html>`
          , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
          , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
        return function(table, hoja) {
          if (!table.nodeType) table = document.getElementById(table)
          var ctx = {worksheet: hoja || 'Worksheet', table: table.innerHTML}
          tmpElemento.href = uri + base64(format(template, ctx))
          tmpElemento.download = 'acttar.xls';
          tmpElemento.click();
        }
      })()
  
      tableToExcel('tabla', 'acttar')
    }
    if(targetName!=="pantalla"&&targetName!=="excel"){
      document.body.style.cursor = 'wait'
      //ACTUALIZAR TARIFA
    let errors = []
    if(this.state.creaColeccAct.length===0&&this.state.creaColeccNOAct.length===0&&this.state.creaColeccMas1Serv.length===0){
      errors.push({path: "Actualizar tarifa", message: "No hay clientes seleccionados para actualizar la tarifa"});
    }
    this.setState({errors})
    if(errors.length===0){
      let listaCliAT = this.state.listaCliAT
      // console.log(listaCliAT)
      let fechaHoy = new Date()
      let horaHoy = fechaHoy.getHours()+":"+fechaHoy.getMinutes()+":"+fechaHoy.getSeconds();
      fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
      
      let miLista = document.getElementById("tarifaA");
      let descrTarifaA = miLista.options[miLista.selectedIndex].text
      miLista = document.getElementById("tarifaN");
      let descrTarifaN = miLista.options[miLista.selectedIndex].text
      let detalle = `${descrTarifaA} A ${descrTarifaN}`
      if(descrTarifaA===descrTarifaN){
        detalle = `${descrTarifaA}`
      }
      let creaHC = []
      listaCliAT.forEach((elemento1, _id) => {
//CREA REGISTRO EN HISTCLIENTES
        let argsAddHC = {
          "fechaHistCliente": fechaHoy + ' ' + horaHoy,
          "contrato": elemento1.contrato,
          "movimiento": "Actualizar tarifa",
          "descripcion": "Proceso masivo",
          "detalle": detalle,
          "usuarioCreate": sessionStorage.getItem('userLogin'),
        }
        creaHC.push(argsAddHC)
      })

//Crear el registro en histclientes
      let creaHCMany = [], creaHCMany1 = []
      creaHC.forEach((elementoHC, ii) => {
        creaHCMany.push(elementoHC)
      })
      creaHCMany1.push({histcliente: creaHCMany})

      let numDocCRUD = 0
      let totDocCRUD = 1
      let argsCrud = []
      let crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.createHistClienteMany)
      }

      argsCrud[numDocCRUD] = creaHCMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.createHistClienteMany

// console.log(argsCrud)
      await updColecc(crudColecc, argsCrud, totDocCRUD)

      // console.log(this.state.creaColeccAct, this.state.creaColeccNOAct, this.state.creaColeccMas1Serv, this.state.creaColeccCSF)

      let actCliMany1 = []
      numDocCRUD = 0
      totDocCRUD = 1
      argsCrud = []
      crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.editClienteUpdDocMany)
      }
      if(this.state.creaColeccAct.length>0){
        // console.log(this.state.creaColeccAct.length)
        let creaColeccAct1 = []
        for(let ii=0; ii<this.state.creaColeccAct.length; ii++){
          creaColeccAct1.push({...this.state.creaColeccAct[ii],
            codigoServicio: this.state.creaColeccAct[ii].tarifa.servicios[0].codigoServicio,
          })
        }

        let creaColeccActServ = []
        creaColeccActServ = _(creaColeccAct1)
        .groupBy('codigoServicio')
        .map((obj, key) => ({
            'codigoServicio': key
          }))
        .value()
        // console.log(creaColeccActServ)

        let creaColeccAct = []
        for(let ii=0; ii<creaColeccActServ.length; ii++){
          // creaColeccAct = this.state.creaColeccAct.filter(elemento => elemento.tarifa.servicios[0].codigoServicio===creaColeccActServ[ii].codigoServicio)
          creaColeccAct = creaColeccAct1.filter(elemento => elemento.codigoServicio===creaColeccActServ[ii].codigoServicio)
          for(let iii=0; iii<creaColeccAct.length; iii++){
            delete creaColeccAct[iii].codigoServicio
          }
          // console.log(creaColeccAct.length, creaColeccAct)

          actCliMany1 = []
          actCliMany1.push({cliente: creaColeccAct})
          // Actualiza el servicio de los clientes ACTIVO
          argsCrud[numDocCRUD] = actCliMany1[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.editClienteUpdDocMany
    
          // console.log(argsCrud)
          // console.log(totDocCRUD)
          await updColecc(crudColecc, argsCrud, totDocCRUD)  
        }
      }
      if(this.state.creaColeccNOAct.length>0){
        // console.log(this.state.creaColeccNOAct.length)
        let creaColeccNOAct1 = []
        for(let ii=0; ii<this.state.creaColeccNOAct.length; ii++){
          creaColeccNOAct1.push({...this.state.creaColeccNOAct[ii],
            codigoServicio: this.state.creaColeccNOAct[ii].tarifa.servicios[0].codigoServicio,
          })
        }

        let creaColeccNOActServ = []
        creaColeccNOActServ = _(creaColeccNOAct1)
        .groupBy('codigoServicio')
        .map((obj, key) => ({
            'codigoServicio': key
          }))
        .value()
        // console.log(creaColeccNOActServ)

        let creaColeccNOAct = []
        for(let ii=0; ii<creaColeccNOActServ.length; ii++){
          // creaColeccNOAct = this.state.creaColeccNOAct.filter(elemento => elemento.tarifa.servicios[0].codigoServicio===creaColeccNOActServ[ii].codigoServicio)
          creaColeccNOAct = creaColeccNOAct1.filter(elemento => elemento.codigoServicio===creaColeccNOActServ[ii].codigoServicio)
          for(let iii=0; iii<creaColeccNOAct.length; iii++){
            delete creaColeccNOAct[iii].codigoServicio
          }
          // console.log(creaColeccNOAct.length, creaColeccNOAct)

          actCliMany1 = []
          actCliMany1.push({cliente: creaColeccNOAct})
          //Actualiza el servicio de los clientes NO ACTIVO
          argsCrud[numDocCRUD] = actCliMany1[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.editClienteUpdDocMany
    
          // console.log(argsCrud)
          // console.log(totDocCRUD)
          await updColecc(crudColecc, argsCrud, totDocCRUD)
        }
      }
      if(this.state.creaColeccMas1Serv.length>0){
        // console.log(this.state.creaColeccMas1Serv.length)
        actCliMany1 = []
        actCliMany1.push({cliente: this.state.creaColeccMas1Serv})
        //Actualiza el servicio de los clientes CON MAS DE UN SERVICIO
        argsCrud[numDocCRUD] = actCliMany1[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.editClienteUpdDocMany
  
        // console.log(argsCrud)
        // console.log(totDocCRUD)
        await updColecc(crudColecc, argsCrud, totDocCRUD)
      }
      
//ACTUALIZAR RENTA MENSUAL EN clientes
      actCliMany1 = []
      actCliMany1.push({cliente: this.state.actRenta})

      numDocCRUD = 0
      totDocCRUD = 1
      argsCrud = []
      crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.editClienteMany)
      }

      argsCrud[numDocCRUD] = actCliMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.editClienteMany
          
      // console.log(argsCrud)
      // console.log(totDocCRUD)
      await updColecc(crudColecc, argsCrud, totDocCRUD)
//FIN ACTUALIZAR RENTA MENSUAL EN clientes

      let creaColeccAct = [], creaColeccNOAct = [], creaColeccMas1Serv = [], actRenta = []
      listaCliAT = []
      this.setState({listaCliAT, creaColeccAct, creaColeccNOAct, creaColeccMas1Serv, actRenta})
  
      alert("!! Proceso finalizado !!")
      
      document.body.style.cursor = 'default'
    }
    document.body.style.cursor = 'default'
  }
console.log("listooooo")
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false, confirmaAct: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = await document.getElementById("btnUpdDel");
        myBtn.click()
    }
  }
  
  async UNSAFE_componentWillMount(){
    if(this.state.argsDocum.fechaPA===""){
      const argsDocum = this.state.argsDocum
      const response = await this.props.fecha({
        variables: {}
      });
      const {fechaFechaHoy} = await response.data.fecha
      argsDocum['fechaPA'] = fechaFechaHoy.substr(0,10)
      this.setState(argsDocum)
    }
  }

  componentDidUpdate(prevProps){
    if(this.props.argsSelDpto.codigoCiudad!==undefined&&this.props.argsSelDpto.codigoCiudad!==""){
      let miLista = document.getElementById("miLista1");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoCiudad){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreCiudad'] = "Todas..."
        argsSelDpto['codigoCiudad'] = ""
        argsSelDpto['codigoCiudadInterno'] = ""
        argsSelDpto['codBarrasRdo'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.codigoZona!==undefined&&this.props.argsSelDpto.codigoZona!==""){
      let miLista = document.getElementById("miLista2");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoZona){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreZona'] = "Todas..."
        argsSelDpto['codigoZona'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.codigoBarrio!==undefined&&this.props.argsSelDpto.codigoBarrio!==""){
      let miLista = document.getElementById("miLista3");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoBarrio){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreBarrio'] = "Todos..."
        argsSelDpto['codigoBarrio'] = ""
        argsSelDpto['codigoTipoDocT'] = ""
        argsSelDpto['numeroDocumT'] = ""
        argsSelDpto['descrRecursoT'] = ""
        argsSelDpto['codigoTipoDocR'] = ""
        argsSelDpto['numeroDocumR'] = ""
        argsSelDpto['descrRecursoR'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.descrDpto!==this.state.argsDocum.descrDpto||
        this.props.argsSelDpto.nombreCiudad!==this.state.argsDocum.nombreCiudad||
        this.props.argsSelDpto.nombreZona!==this.state.argsDocum.nombreZona||
        this.props.argsSelDpto.nombreBarrio!==this.state.argsDocum.nombreBarrio){
      const argsDocum = this.state.argsDocum
      argsDocum.descrDpto = this.props.argsSelDpto.descrDpto
      argsDocum.nombreCiudad = this.props.argsSelDpto.nombreCiudad
      argsDocum.nombreZona = this.props.argsSelDpto.nombreZona
      argsDocum.nombreBarrio = this.props.argsSelDpto.nombreBarrio
      this.setState({argsDocum});
      this.setState({argsSelDpto: this.props.argsSelDpto})
      let listaCliAT = [], creaColeccAct = [], creaColeccNOAct = [], creaColeccMas1Serv = []
      this.setState({listaCliAT, creaColeccAct, creaColeccNOAct, creaColeccMas1Serv})
    }

    // if(this.props.argsSelDpto!==prevProps.argsSelDpto){
    //   this.setState({argsSelDpto: this.props.argsSelDpto})
    // }
  }

  render(){
    const {argsDocum, listaCliAT, totCli, permiteUpdate, confirmaAct, open, errors} = this.state;

    if(this.props.codigoCiudadUA!=="Todas..."){
      let dpto = document.getElementById("miLista");
      if(dpto){
        dpto.options.selectedIndex = 0
      }
    }

    let colecc = selDirmayor(this.props.list1, this.props.argsSelDpto, this.props.codigoCiudadUA)
    let listCiu = colecc.listCiu
    let listZon = colecc.listZon
    let listBar = colecc.listBar

    // let fechaHoy = new Date()
    // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
    
    let list6 = [], descrTarifaA = "", descrTarifaN = ""
    if(this.props.allTarifa.allTarifa){
      list6 = this.props.allTarifa.allTarifa
      let indexLis = -1
      if(argsDocum.codigoTarifaA==="Seleccionar..."){
        descrTarifaA = "Tarifa actual"
      }else{
        indexLis = list6.findIndex( tarifaa => tarifaa.codigoTarifa === argsDocum.codigoTarifaA );
        descrTarifaA = list6[indexLis].descrTarifa
      }
      if(argsDocum.codigoTarifaN==="Seleccionar..."){
        descrTarifaN = "Tarifa nueva"
      }else{
        indexLis = list6.findIndex( tarifaa => tarifaa.codigoTarifa === argsDocum.codigoTarifaN );
        descrTarifaN = list6[indexLis].descrTarifa
      }
    }
// console.log(list6)
    let mensaje = "ACTUALIZAR TARIFA"
    let imgIcon = "images/archivo_32.png"
// console.log(this.props.allClientesRtes.allClientesRtes)
    // console.log(this.props.allTarifa.allTarifa)
// console.log(this.props.list3)
// console.log(this.state.argsSelDpto)
    return(
      <div>
          <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
              <i className="large edit yellow icon"></i>
              Actualizar tarifa
          </button>
          <div>
                    <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
                    <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev):()=>{}}>
                        <div>
                            <div className="ui two column stackable grid">
                                <div className="row container">
                                    <div className="column" style={{width: '40%'}}>
                                      <h1 style={{color: '#2C7744'}}>Actualizar tarifa a clientes</h1>
                                      <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0em'}}>
                                        La tarifa nueva debe tener todos los servicios de la tarifa actual<br/>
                                        Los servicios quedarán con los valores de la tarifa nueva
                                      </p>
                                    </div>
                                    <div className="column" style={{width: '60%'}}>
                                      <p>
                                        <span style={{background: '#7F7FD5', padding: '0.5em', color: '#952007', fontSize: '1.7em'}} className='ui basic label'>
                                          Fecha de Primera Activación anterior o igual a: &nbsp;&nbsp;
                                          <span>
                                            <input value={argsDocum.fechaPA} style={{color: '#302b63', fontSize: '2em', padding: '0.5em'}} type='date' name="fechaPA" id="fechaPA" onChange={this.handleChange}/>
                                          </span>
                                        </span>
                                      </p>
                                    </div>
                                </div>
                            </div>
                            <hr></hr>
                            <hr></hr>
                            <div className="ui two column stackable grid">
                              <div className="row container">
                              <div className="column" style={{width: '50%'}}>
                                  <Form.Field>
                                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Tarifa actual
                                    </label>
                                    <ListaTarA styles={this.props.styles} list={list6} handleChange={this.handleChange} />
                                  </Form.Field>
                                </div>
                                <div className="column" style={{width: '50%'}}>
                                  <Form.Field>
                                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Tarifa nueva
                                    </label>
                                    <ListaTarN styles={this.props.styles} list={list6} handleChange={this.handleChange} />
                                  </Form.Field>
                                </div>
                              </div>
                            </div>
                            <hr></hr>
                            <hr></hr>
                            <div className="ui two column stackable grid">
                              <div className="row container">
                                <div className="column" style={{width: '50%'}}>
                                  <Form.Field>
                                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Departamento
                                    </label>
                                    <ListaDe list={this.props.list1} styles={this.props.styles}
                                      handleLista={this.props.handleLista} codigoCiudadUA={this.props.codigoCiudadUA}
                                      codigoDptoUA={this.props.codigoDptoUA}/>
                                  </Form.Field>
                                </div>
                                <div className="column" style={{width: '50%'}}>
                                  <Form.Field>
                                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Ciudad
                                    </label>
                                    <ListaCi list={listCiu} styles={this.props.styles}
                                      handleLista1={this.props.handleLista1} argsSelDpto={this.props.argsSelDpto}
                                      codigoCiudadUA={this.props.codigoCiudadUA}/>
                                  </Form.Field>
                                </div>
                                <div className="column" style={{width: '50%'}}>
                                  <Form.Field>
                                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Zona
                                    </label>
                                    <ListaZo list={listZon} styles={this.props.styles}
                                      handleLista2={this.props.handleLista2} argsSelDpto={this.props.argsSelDpto}/>
                                  </Form.Field>
                                </div>
                                <div className="column" style={{width: '50%'}}>
                                  <Form.Field>
                                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Barrio
                                    </label>
                                    <ListaBa list={listBar} styles={this.props.styles}
                                      handleLista3={this.props.handleLista3} argsSelDpto={this.props.argsSelDpto}/>
                                  </Form.Field>
                                </div>
                              </div>
                            </div>

                            <hr></hr>
                            <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                              Estrato
                            </p>
                            <Form.Field>
                              <ListaES styles={this.props.styles} list={this.props.list3} handleChange={this.handleChange} />
                            </Form.Field>
                            <hr></hr>

                            <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                              Total Clientes:&nbsp;
                              {totCli}
                            </p>


                            <div className="ui three column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '34%'}}>
                      <Button id="pantalla" name="pantalla" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev)} fluid>
                        VER CLIENTES
                      </Button>
                    </div>
                    <div className="column" style={{width: '33%'}}>
                      <Button id="excel" name="excel" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev)} fluid>
                        ARCHIVO EXCEL
                      </Button>
                    </div>
                    <div className="column" style={{width: '33%'}}>
                      <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                    </div>
                  </div>
                </div>
                <hr></hr>

                <div style={{height: '40em', overflow: 'auto'}}>
                            {/* <div className="ui two column stackable grid">
                              <div className="row container">
                                <div className="column" style={{width: '50%'}}>
                                  <Button id="pantalla" name="pantalla" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev)} fluid>
                                      VER CLIENTES
                                  </Button>
                                </div>
                                <div className="column" style={{width: '50%'}}>
                                  <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                                </div>
                              </div>
                            </div> */}
                            {/* <hr></hr> */}
                            <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                              <thead className=''>
                                <tr className=''>
                                  <th rowSpan='2'  className=''>Contrato</th>
                                  <th rowSpan='2'  className=''>Clase</th>
                                  <th rowSpan='2'  className=''>Servicio</th>
                                  <th colSpan='2' className='center aligned'>{descrTarifaA} ={">"}</th>
                                  <th colSpan='2' className='center aligned'>{descrTarifaN}</th>
                                </tr>
                                <tr className=''>
                                  <th className='right aligned'>$ Total</th>
                                  <th className='right aligned'>$ Antes Imptos</th>
                                  <th className='right aligned'>$ Total</th>
                                  <th className='right aligned'>$ Antes Imptos</th>
                                </tr>
                              </thead>
                              <ListaAT list={listaCliAT}/>
                            </table>
                        </div>
                      </div>
                      {
                          errors.length?<Message negative header="Los siguientes errores:"
                          list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                      }

                      </Form>
                    </div>
                </div>
      </div>
    )
  }
}

export default compose(
  // graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: argsBuscarCL}}}),
  graphql(queries.query.allClientesRtes, {name:'allClientesRtes', options: (props) => {return {variables: {tipoqry: `[{$match: {contrato: "XXXYYYZZZ"}}]`}}}}),

  graphql(queries.query.allTarifa, {name:'allTarifa', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.editClienteUpdDocMany, {name:'editClienteUpdDocMany'}),
  graphql(queries.mutation.createHistClienteMany, {name:'createHistClienteMany'}),

  graphql(queries.mutation.editClienteMany, {name:'editClienteMany'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
  )(ProcAT2)
